import colors from 'src/integration/styles/colors';
import fonts from 'src/integration/styles/fonts';
import Chart from 'chart.js/auto';
import { Plugin } from 'chart.js';
import { scaleChartSize } from 'src/integration/settings/graphSettings';

export const yAxisTitlePlugin = {
  id: 'yAxisTitlePlugin',
  beforeInit(chart: any, _args: any, options: any) {
    chart.$yAxisTitleLabels = options.labels ?? { y: options.label ?? '' };
  },
  afterDraw(chart: any) {
    const { ctx, chartArea, scales } = chart;
    const axisLabelFontSize = scaleChartSize(16);
    const axisLabelTopOffset = scaleChartSize(20);
    const axisLabelRightOffset = scaleChartSize(30);

    ctx.save();
    ctx.font = `${axisLabelFontSize}px ${fonts.fontFamily.body}`;
    ctx.fillStyle = colors.primaryDarkJungleGreen;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'bottom';

    // Draw Y axis label (left)
    if (chart.$yAxisTitleLabels.y && scales.y) {
      ctx.textAlign = 'left';
      const yTop = chartArea.top - axisLabelTopOffset;
      ctx.fillText(chart.$yAxisTitleLabels.y, 0, yTop);
    }

    // Draw Y1 axis label (right)
    if (chart.$yAxisTitleLabels.y1 && scales.y1) {
      ctx.textAlign = 'right';
      const xRight = chartArea.right + axisLabelRightOffset;
      const yTop = chartArea.top - axisLabelTopOffset;
      ctx.fillText(chart.$yAxisTitleLabels.y1, xRight, yTop);
    }

    ctx.restore();
  },
};


export const spacerPlugin = {
  id: 'spacer',
  beforeInit(chart: any) {
    const originalFit = chart.legend.fit;
    chart.legend.fit = function fit() {
      originalFit.bind(chart.legend)();
      this.height += scaleChartSize(60);
    };
  },
};

export const drawTooltipLine = (
  context: any,
  chartRef: React.RefObject<Chart<'line'>>
) => {
  const chart = chartRef.current;
  if (!chart) return;

  const { tooltip } = context;
  const ctx = chart.ctx;
  if (tooltip.opacity === 0) return;

  ctx.save();
  const x = tooltip.caretX;
  ctx.beginPath();
  ctx.setLineDash([5, 5]);
  ctx.moveTo(x, chart.chartArea.top);
  ctx.lineTo(x, chart.chartArea.bottom);
  ctx.lineWidth = 2;
  ctx.strokeStyle = colors.text.warning;
  ctx.stroke();
  ctx.restore();
};

export const highlightTimeSlotsPlugin = (
  slots: { start: string; end: string }[]
): Plugin<'line'> => ({
  id: 'highlightTimeSlots',
  beforeDatasetsDraw(chart) {
    const { ctx, chartArea } = chart;
    const xScale = chart.scales['x'];
    const labels = chart.data.labels as string[];

    const tradingDatasetIndex = chart.data.datasets.findIndex(
      (ds) => ds.label === 'Trading event'
    );

    if (
      tradingDatasetIndex === -1 ||
      chart.getDatasetMeta(tradingDatasetIndex).hidden
    ) {
      return;
    }

    ctx.save();
    ctx.fillStyle = colors.backgound.success;

    slots.forEach(({ start, end }) => {
      const startIndex = labels.indexOf(start);
      const endIndex = labels.indexOf(end);

      if (startIndex !== -1 && endIndex !== -1) {
        const startX = xScale.getPixelForValue(startIndex);
        const endX = xScale.getPixelForValue(endIndex);
        ctx.fillRect(startX, chartArea.top, endX - startX, chartArea.bottom - chartArea.top);
      }
    });

    ctx.restore();
  },
});